import crypto from 'crypto';
import { STATUS } from '../config/constants/states';

const decode = (t) => {
  const buff = Buffer.from(t, 'base64');
  const text = buff.toString('utf-8');
  const res = text.split(':');

  if (res[3] !== crypto.createHash('sha256').update(`${res[0]}:${res[1]}:${res[2]}`).digest('hex')) {
    return STATUS.ERROR;
  }

  return res;
};

export default decode;